export default "__VITE_ASSET__dGQ_HLht__"